import { Typography, useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import InViewAnimationComponent from '../in-view-animation-container';

export const DeviceStatus = ({ device }) => {
  const theme = useTheme();
  return (
    <InViewAnimationComponent>
      <Stack
        alignItems="center"
        justifyContent="center"
        flexDirection="row"
        gap={2}
        marginTop={-5}
        sx={{
          width: 1,
          mx: 'auto',
          maxWidth: 480,
          px: { xs: 2, md: 4 },
          // pt: { xs: 15, md: 20 },
          py: { xs: 2, md: 4 },
          bgcolor: theme.palette.background.default,
          boxShadow: theme.customShadows.z24,
          borderRadius: theme.shape.borderRadius * 0.3,
        }}
      >
        <Stack alignItems="flex-start">
          <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
            Mac Address :
          </Typography>
          <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
            Status :
          </Typography>
          <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
            Expiration :
          </Typography>
        </Stack>
        <Stack alignItems="flex-end">
          <Typography variant="subtitle1" sx={{ textAlign: 'center', fontWeight: 'light' }}>
            {device.mac_address}
          </Typography>
          <Typography variant="subtitle1" sx={{ textAlign: 'center', fontWeight: 'light' }}>
            {device.is_trial ? 'Active' : 'Inactive'}
          </Typography>
          <Typography variant="subtitle1" sx={{ textAlign: 'center', fontWeight: 'light' }}>
            {device.expire_date}
          </Typography>
        </Stack>
      </Stack>
    </InViewAnimationComponent>
  );
};
